
import { Wifi } from "lucide-react";

interface LogoProps {
  className?: string;
}

export const Logo = ({ className = "" }: LogoProps) => {
  return (
    <div className={`flex items-center ${className}`}>
      <Wifi className="h-6 w-6 text-primary mr-2" />
      <span className="text-xl font-bold">
        Abo<span className="text-primary">n</span><span className="text-primary">emt</span>
      </span>
    </div>
  );
};
